import React from 'react'
import LenderUgroService from '../../../services/lender';
import { toast } from 'react-toastify';
import { downloadFile } from '../../../common/download';
import { useRouter } from '../../../hooks/useRouter';

const DownloadLogsFileData = ({ row }) => {
    const params = useRouter()
    const fileType = params?.pathname?.split('/')?.[2];
    const lenderId = params?.pathname?.split('/')?.[3];
    const fileName = row?.req_json.split('/')?.[3];
    const downloadBulkUploadFile = async (fileUrl) => {
        try {
            const response = await LenderUgroService.downloadLogFile({
                fileUrl,
                fileType,
                responseType: 'blob',
                lenderId
            });
            downloadFile(response?.data, fileUrl)
        } catch (err) {
            toast(
                err.response?.data?.messages?.error?.file?.[0] ||
                err.response?.data?.messages?.error?.form?.[0] ||
                err.response?.data?.messages?.error?.others?.[0]
            )
        }
    }
    return (
        row?.req_json ?
        <div style={{ cursor: 'pointer' }} onClick={() => downloadBulkUploadFile(row?.req_json)}>
            <span>{fileName}</span>
            <span className='ml-3' style={{ cursor: 'pointer' , color: '#0ba6ff' }}><i class="fa fa-download" aria-hidden="true"></i></span>
        </div>
        :
        <div>
            <span>{fileName}</span>
        </div>
    )
}

export default DownloadLogsFileData